import { put, call, takeLatest, delay } from 'redux-saga/effects';
import axios from 'axios';
import config from '../config';
import Cookies from 'js-cookie';
//Action
import { loadingSet } from '../action/uiAction';


function* communityPostListGet(action) {
  yield put(loadingSet(true));

  let page = (action.payload.page) ? action.payload.page : 1;

  const {res, err} = yield call(function (payload) {
    const params = new URLSearchParams();
    params.append('ULIC', Cookies.get('ULIC'));
    params.append('ULPC', Cookies.get('ULPC'));
    params.append('page', page);
    let lsObj = JSON.parse(localStorage.getItem('PostCondition'));
    if (lsObj.sex) {
      lsObj.sex.map( (value, index) => params.append('sex[]', value) );
    }
    if (lsObj.age) {
      params.append('age[]', lsObj.age.low);
      params.append('age[]', lsObj.age.high)
    }
    if (lsObj.region) {
      lsObj.region.map( (value, index) => params.append('region[]', value) );
    }
    if (lsObj.date) {
      params.append('date', lsObj.date);
    }
    if (lsObj.keyword) {
      lsObj.keyword.split(" ").map( (value, index) => params.append('keyword[]', value) );
    }
    return axios.post(config.apiUri + "member/communityPostListApi.php", params, {
      timeout: 10000
    })
    .then((res) => {
      return {res};
    })
    .catch((err) => {
      return {err};
    })
  }, action.payload);
  yield delay(100);
  if (res) {
    if (res.data.bool) {
      yield put({
        type: "COMMUNITY_POST_LIST_SET",
        payload: {
          list: res.data.list,
          page: page,
          isListNext: res.data.isListNext,
        },
      });
    }
  }

  if (err) {
    yield put({ type: 'SNACK_SET', payload: {visible: true, severity: 'error', duration: 5000, comment: config.apiErrComment} });
  }
  yield put(loadingSet(false));
}

const saga = [
  takeLatest('COMMUNITY_POST_LIST_GET', communityPostListGet),
];

export default saga;
